module.exports = __webpack_public_path__ + "static/img/2.6a6763f3.png";